import { render } from "./UiFormField.vue?vue&type=template&id=f484757e"
import script from "./UiFormField.vue?vue&type=script&lang=js"
export * from "./UiFormField.vue?vue&type=script&lang=js"

import exportComponent from "D:\\laragon\\www\\leader-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__